module.exports = __webpack_public_path__ + "img/ic_complete_60.d1d83c9f.png";